import { Check, WarningAmberOutlined } from '@mui/icons-material';
import { Alert, Box, Button, styled } from '@mui/material';

export const SidebarContainer = styled(Box)(
  ({ theme }) => `
  border-top: 1px solid ${theme.palette.divider};
`,
);

export const StyledAlert = styled(Alert)`
  margin: 16px;
  text-align: center;
`;

export const ScreenWrapper = styled(Box)(
  ({ theme }) => `
  display: flex;
  align-items: center;
  height: 64px;
  padding: 8px 16px;
  border-bottom: 1px solid ${theme.palette.divider};
`,
);

export const ScreenTextWrapper = styled(Box)`
  display: flex;
  align-items: center;
  flex: 1;
`;

export const CheckIcon = styled(Check)`
  margin-left: 8px;
`;

export const ScheduleComponentButton = styled(Button)`
  padding: 0 20px;
  height: 42px;
`;

export const StyledWarningIcon = styled(WarningAmberOutlined)(
  ({ theme }) => `
    margin-left: 8px;
    color:${theme.palette.brand?.warning};
`,
);
